__turbopack_context__.v({
  "header": "styles-module__g4OPgG__header",
  "leftButtons": "styles-module__g4OPgG__leftButtons",
  "rightButtons": "styles-module__g4OPgG__rightButtons",
});
